import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { Spinner } from '@/components/ui'
import { createContact, emptyContact, updateContact } from '../contactsSlice'
import PersonnePhysiqueForm from './PersonnePhysiqueForm'
import PersonneMoraleForm from './PersonneMoraleForm'
import GLIInfoSection from './GLIInfoSectionForm'
import useFormConfirmation from '@/hooks/useFormConfirmation.jsx'

const ContactForm = ({ fixType, onSuccess, onClose }) => {
  const dispatch = useDispatch();
  const [ typeIsFixed ] = useState(fixType || false)
  const contact = useSelector((state) => state.contacts.current || emptyContact)
  const errors = useSelector((state) => state.contacts.requestStatus.errors)
  const isCreating = useSelector((state) => state.contacts.loadingStatus.create)
  const isUpdating = useSelector((state) => state.contacts.loadingStatus.update)
  const isLoading = isCreating || isUpdating

  const { register, handleSubmit, watch, reset, setValue, control, formState: { isDirty, errors: formErrors } } = useForm({
    defaultValues: contact,
    mode: 'onChange',
    reValidateMode: 'onChange'
  })

  // Type est accessible via watch
  const type = watch('type')

  // Synchroniser le formulaire lorsque contact change
  useEffect(() => {
    if (contact) {
      Object.entries(contact).forEach(([key, value]) => {
        setValue(key, value);
      });
    }
  }, [contact, setValue]);

  const onSubmit = async (formData) => {
    if (contact.id) {
      await dispatch(updateContact({ id: contact.id, contactData: formData }));
    } else {
      await dispatch(createContact(formData));
    }
    onSuccess?.()
  }

  const onCancel = () => {
    reset(contact)
    onClose()
  }

  const {
    handleFormCancel,
    FormConfirmDialog
  } = useFormConfirmation({
    isDirty,
    onClose: onCancel
  })

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex justify-between items-center p-4">
          <h1 className="text-2xl mb-2">{contact.id ? `${contact.nom_complet}` : 'Nouveau contact'}</h1>
          { !typeIsFixed && (
            <label className='select'>
              <span className='label'>Type</span>
              <select name='type' {...register('type')} defaultValue={type || "PersonnePhysique"}>
                <option value={"PersonnePhysique"}>Personne Physique</option>
                <option value={"PersonneMorale"}>Personne Morale</option>
              </select>
            </label>
          )}
        </div>
        
        <div className="card bg-base-100 border border-base-200 rounded-none mb-4">
          <div className="card-body p-2">
            <h2 className="text-xl mb-2">Informations générales</h2>
            {type === 'PersonnePhysique' && <PersonnePhysiqueForm control={control} errors={formErrors} apiErrors={errors} />}
            {type === 'PersonneMorale' && <PersonneMoraleForm 
              control={control} watch={watch}
              errors={formErrors} apiErrors={errors}
            />}
          </div>
        </div>
        
        { type === "PersonnePhysique" && <GLIInfoSection control={control} errors={formErrors} /> }

        <div className="flex justify-between">
          <button
            type="button"
            className="btn btn-outline"
            onClick={handleFormCancel}
          >
            Annuler
          </button>
          <button
            type="submit"
            className={`btn ${isLoading ? 'loading' : ''} btn-primary text-white p-2 mt-4`}
            disabled={isLoading}
          >
            {isLoading ? <Spinner/> : 'Enregistrer'}
          </button>
        </div>
      </form>
      <FormConfirmDialog />
    </div>
  )
}

export default ContactForm